"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpgradeModalComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var billingComponent_1 = require("./billingComponent");
var react_1 = require("@heroui/react");
var label_1 = require("../controls/label");
var constants_1 = require("../constants/constants");
var useClientSubscriptionStatus_1 = require("../hooks/useClientSubscriptionStatus");
var main_1 = require("../reducers/slices/main");
var react_router_dom_1 = require("react-router-dom");
var UpgradeModalComponent = function (_a) {
    var message = _a.message;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var isUnsubscribed = (0, useClientSubscriptionStatus_1.useClientSubscriptionStatus)().isUnsubscribed;
    var _showPlans = function () {
        dispatch((0, main_1.setContentModal)(null));
        if (!isUnsubscribed)
            return window.open(process.env.STRIPE_BILLING_URL, "_blank");
        setTimeout(function () {
            dispatch((0, main_1.setContentModal)({
                title: constants_1.UPGRADE_MODAL_TITLE,
                content: (0, jsx_runtime_1.jsx)(billingComponent_1.BillingComponent, {}),
            }));
        }, 300);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex gap-4 flex-col", children: [(0, jsx_runtime_1.jsx)(label_1.Label, { label: message !== null && message !== void 0 ? message : "Please upgrade your subsciption to access this feature" }), (0, jsx_runtime_1.jsxs)("div", { className: "flex gap-4 flex-row justify-center", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "tertiary", onPress: function () { return dispatch((0, main_1.setContentModal)(null)); }, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "primary", onPress: function () { return _showPlans(); }, children: "Yes, Continue" })] })] }));
};
exports.UpgradeModalComponent = UpgradeModalComponent;
